export default __webpack_public_path__ + "static/media/shutterstock_688478083.729f8a43.png";